import { request } from 'sonata-react-components';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

export async function getUserAlias(user: Record<string, any>, token: Record<string, any>): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userAlias/data`,
    {
      method: 'GET',
      params: {
        parentUserId: user.id
      }
    },
    token
  );
}

export async function getAliasById(aliasId: string, token: Record<string, any>): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userAlias/${aliasId}`,
    {
      method: 'GET'
    },
    token
  );
}

export async function postUserAlias(newAlias: UserInterface, token: Record<string, any>): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userAlias`,
    {
      data: newAlias,
      method: 'POST'
    },
    token
  );
}

export async function deleteUserAlias(alias: Record<string, any>, token: Record<string, any>): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userAlias/${alias._id}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export async function updateUserAlias(alias: Record<string, any>, token: Record<string, any>): Promise<any> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}userAlias/${alias.id}`,
    {
      data: alias,
      method: 'PUT'
    },
    token
  );
}
